/**
 * Inbox API — row-per-blogger aggregation для /inbox (Phase 74; F10 full-screen).
 */
import apiClient from './client.js';

export async function fetchInbox (params = {}) {
  const { limit = 100, offset = 0, channel, unreadOnly, from, to, category, managerId } = params;
  const { data } = await apiClient.get('/inbox', {
    params: { limit, offset, channel, unreadOnly, from, to, category, managerId: managerId || undefined },
  });
  return data;   // { ok, total, rows: [...], hasMore }
}

export async function fetchInboxCategories (managerId) {
  const { data } = await apiClient.get('/inbox/categories', {
    params: { managerId: managerId || undefined },
  });
  // { categories: [{ category: string|null, count }], unreadCount }
  return { categories: data?.categories || [], unreadCount: data?.unreadCount ?? 0 };
}

export async function markLeadUnread (leadId) {
  const { data } = await apiClient.patch(`/leads/${leadId}/mark-unread`);
  return data;
}

export async function markLeadRead (leadId) {
  const { data } = await apiClient.patch(`/leads/${leadId}/mark-read`);
  return data;
}

export async function syncReplyThread (leadId) {
  const { data } = await apiClient.post(`/inbox/${leadId}/sync-reply`, undefined, { timeout: 60000 });
  return data; // { ok, rebuilt, linked, threads }
}
